import axios from 'axios';

export const getAddressByCep = async (cep) => {
  return await axios
    .get(`https://viacep.com.br/ws/${cep}/json/`)
    .then((response) => {
      return response.data;
    });
};
